export const ErrorNotif = ({ size = 31 }) => {
  return (
    <svg
      width={`${size}`}
      height={`${size}`}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 0H2C0.895431 0 0 0.910207 0 2.033V24.6293C0 25.7521 0.895431 26.6623 2 26.6623H11.3739C12.073 26.6623 12.7214 27.0334 13.084 27.641L15.5389 31.7553C15.7412 32.0942 16.2302 32.0779 16.4101 31.7262L18.4398 27.7575C18.784 27.0845 19.4682 26.6623 20.2144 26.6623H30C31.1046 26.6623 32 25.7521 32 24.6293V2.033C32 0.910205 31.1046 0 30 0Z"
        fill="#F34653"
      />
      <circle cx="15.6797" cy="20.0542" r="1.67973" fill="white" />
      <rect x="14" y="6" width="3.35945" height="10.7485" rx="1" fill="white" />
    </svg>
  );
};
